import { isActionOf } from "typesafe-actions";

import { showErrorToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import type { GetRequestOptions } from "app/services/fetchService";
import { NoCacheHeaders } from "app/services/fetchService";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { AssignToUserRequestParams } from "../types/common";

import * as ac from "./actions-creators";

export function fetchAssignableUsersThunk(options?: GetRequestOptions) {
    return async function fetchAssignableUsers(
        dispatch: ThunkDispatchCommon,
        _getState: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchAssignableUsersAsync.request());

        try {
            const users = await deps.si.api.assignToUsers.fetchAssignableUsers(options);

            return dispatch(ac.fetchAssignableUsersAsync.success(users));
        } catch (e) {
            return dispatch(ac.fetchAssignableUsersAsync.failure(e));
        }
    };
}

function assignLeadsToUserThunk(params: AssignToUserRequestParams) {
    return async function assignLeadsToUser(
        dispatch: ThunkDispatchCommon,
        _getState: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.assignToUserAsync.request());

        try {
            await deps.si.api.assignToUsers.assignWebsitesToUser(params);
            return dispatch(ac.assignToUserAsync.success());
        } catch (e) {
            return dispatch(ac.assignToUserAsync.failure(e));
        }
    };
}

export function assignLeadsToUserWithToastThunk(params: AssignToUserRequestParams) {
    return async function assignLeadsToUserWithToast(
        dispatch: ThunkDispatchCommon,
        _getState: ThunkGetState,
        { si: { settingsHelper } }: ThunkDependencies,
    ) {
        const assignResultAction = await dispatch(assignLeadsToUserThunk(params));
        const isSuccessfulAction = isActionOf(ac.assignToUserAsync.success);
        const isErrorAction = isActionOf(ac.assignToUserAsync.failure);

        if (isSuccessfulAction(assignResultAction)) {
            dispatch(fetchAssignableUsersThunk({ headers: NoCacheHeaders }));
        }

        if (isErrorAction(assignResultAction)) {
            const toast = getToastItemComponent({
                text: `${translate("si.common.toast.error")}`,
            });

            dispatch(showErrorToast(toast));
        }
    };
}
